/* eslint camelcase: 0 */
import React, { Component } from 'react';
import { provideHooks } from 'redial';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { extractUtmSourceFromUrl } from '../../../utils/helper';
import { updateRenderData } from '../../../actionCreators/home';
import { getCampaignData } from '../../../actionCreators/campaign';
import { changeLogo } from '../../../actionCreators/common';
import BannerAndCarouselRenderer from '../../components/Common/BannerAndCarouselRenderer';
import DesktopOfferModal from '../../../CommonComponents/OfferCampaign/DesktopOfferModal';
import { isEmptyObject, hideRepeatUserElem } from '../../../utils/helper';
import Customevent from '../../../utils/Customevent';
import './Home.scss';
import './Header-banner.scss';

@provideHooks({
  fetch: ({ location, store: { dispatch, getState } }) => {
    let path =
      location.pathname.length > 1 ? location.pathname.slice(1).replace(/(\/+)$/g, '') : '/';
    path = path !== '' ? path : '/';
    const { redisCommonData } = getState().common;
    // https://valyoo.atlassian.net/browse/LKUI-1305
    // dispatch(commonActions.changeLogo('lenskart'));
    if (
      ['eyeglasses.html', 'sunglasses.html', 'premium-eyeglasses', 'premium-sunglasses'].includes(
        path
      ) ||
      path.indexOf('promo/') > -1
    ) {
      if (Object.keys(redisCommonData).length) {
        if (
          redisCommonData.RBI_POLICY_MARKETPLACE_CONFIG &&
          JSON.parse(redisCommonData.RBI_POLICY_MARKETPLACE_CONFIG).listing === 'ON'
        ) {
          if (
            path.toLowerCase().indexOf('sun') > -1 ||
            path.toLowerCase().indexOf('contact') > -1 ||
            path.toLowerCase().indexOf('solution') > -1 ||
            path.toLowerCase().indexOf('accessor') > -1 ||
            path.toLowerCase().indexOf('reading') > -1
          ) {
            dispatch(changeLogo('dealskart'));
          } else {
            dispatch(changeLogo('lenskart'));
          }
        } else {
          dispatch(changeLogo('lenskart'));
        }
      }
    } else {
      dispatch(changeLogo('lenskart'));
    }
    const pageContext = path === '/' ? 'home' : path.replace('.html', '').replace(/\//g, '-');
    dispatch(getCampaignData({ pageContext }));
  },
})
class Home extends Component {
  static propTypes = {
    homepageData: PropTypes.object,
    renderData: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.state = {
      showOfferModal: false,
    };
    this.handleScroll = this.handleScroll.bind(this);
    this.dataLayerLoad = true;
    this.dataLayerIndex = 0;
    this.isRepeatUser = null;
    this.checkRepeatUser = this.checkRepeatUser.bind(this);
  }
  componentDidMount() {
    const { redisCommonData, changeLogo } = this.props;
    // loadCarousalsData();
    window.addEventListener('scroll', this.handleScroll);
    this.setDataLayer();
    if (window.dtm && window.dtm.LenskartRewamp) {
      window.dtm.LenskartRewamp.Home.load.getSessionID();
      let path =
        this.props.location && this.props.location.pathname.length > 1
          ? this.props.location.pathname.slice(1).replace(/(\/+)$/g, '')
          : '/';
      path = path !== '' ? path : '/';
      if (path === '/') {
        window.dtm.LenskartRewamp.Home.load.homepageLoad();
        changeLogo('lenskart');
      } else if (
        'eyeglasses.html,sunglasses.html,premium-eyeglasses,premium-sunglasses'.includes(path) ||
        path.indexOf('promo/') > -1
      ) {
        window.dtm.LenskartRewamp.cms.load.cmsOnLoad(path);
        if (
          redisCommonData.RBI_POLICY_MARKETPLACE_CONFIG &&
          JSON.parse(redisCommonData.RBI_POLICY_MARKETPLACE_CONFIG).listing === 'ON'
        ) {
          if (
            path.toLowerCase().indexOf('sun') > -1 ||
            path.toLowerCase().indexOf('contact') > -1 ||
            path.toLowerCase().indexOf('solution') > -1 ||
            path.toLowerCase().indexOf('accessor') > -1 ||
            path.toLowerCase().indexOf('reading') > -1
          ) {
            changeLogo('dealskart');
          } else {
            changeLogo('lenskart');
          }
        } else {
          changeLogo('lenskart');
        }
      }
    }
    if (!isEmptyObject(this.props.homepageData)) {
      this.triggerEventForhomepageDataload();
    }
    // ipl-unlock-offer event to open Offer modal
    document.addEventListener('iplUnloadOfferEvent', () => {
      this.renderOfferModal(true);
    });
    if (sessionStorage.getItem('offerSelected')) sessionStorage.removeItem('offerSelected');
  }

  shouldComponentUpdate(nextProps) {
    const { userInfo, cartData, renderData, homepageData } = this.props;
    if (
      !userInfo &&
      !nextProps.userInfo &&
      renderData &&
      renderData.length === nextProps.renderData.length &&
      homepageData &&
      homepageData.length === nextProps.homepageData.length
    ) {
      return false;
    }
    if (userInfo !== nextProps.userInfo || cartData !== nextProps.cartData) {
      this.setDataLayer(nextProps);
      return false;
    }
    return true;
  }

  componentDidUpdate(prevProps) {
    const { renderData } = this.props;
    if (prevProps.location.pathname !== this.props.location.pathname && window.dtm.LenskartRewamp) {
      window.dtm.LenskartRewamp.Home.load.getSessionID();
      let path =
        this.props.location && this.props.location.pathname.length > 1
          ? this.props.location.pathname.slice(1).replace(/(\/+)$/g, '')
          : '/';
      path = path !== '' ? path : '/';
      if (path === '/') {
        window.dtm.LenskartRewamp.Home.load.homepageLoad();
      } else if (
        'eyeglasses.html,sunglasses.html,premium-eyeglasses,premium-sunglasses'.includes(path)
      ) {
        window.dtm.LenskartRewamp.cms.load.cmsOnLoad(path);
      }
    }

    if (prevProps.loginStatus !== this.props.loginStatus && this.props.loginStatus) {
      const redirectUrl = this.props.location.state ? this.props.location.state.redirectUrl : '';
      if (redirectUrl) {
        this.props.history(redirectUrl);
      }
    }

    const isGoBack = sessionStorage.getItem('backTrigger');
    if (isGoBack === 'true' && renderData && renderData.length > 2) {
      this.checkRepeatUser();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  setDataLayer = props => {
    if (props) {
      const userInfo = props.userInfo;
      const dataLayer = window.dataLayer;
      const cartObject = props.cartData;
      const orderTotal =
        typeof cartObject !== 'undefined' &&
        cartObject !== null &&
        typeof cartObject.result !== 'undefined' &&
        typeof cartObject.result.totals !== 'undefined' &&
        typeof cartObject.result.totals.total !== 'undefined'
          ? cartObject.result.totals.total
          : null;
      let userEmail;
      let userMobile;
      if (
        typeof cartObject !== 'undefined' &&
        cartObject !== null &&
        typeof cartObject.result !== 'undefined' &&
        dataLayer[this.dataLayerIndex]
      ) {
        dataLayer[this.dataLayerIndex].netAmount = orderTotal;
        dataLayer[this.dataLayerIndex].orderTotal = orderTotal;
      }
      if (
        typeof userInfo !== 'undefined' &&
        userInfo !== null &&
        typeof userInfo.result !== 'undefined' &&
        dataLayer[this.dataLayerIndex]
      ) {
        userEmail = userInfo.result.email;
        userMobile = userInfo.result.telephone;
        dataLayer[this.dataLayerIndex].EmailId = userEmail;
        dataLayer[this.dataLayerIndex].mobile =
          typeof window !== 'undefined' &&
          typeof window.btoa !== 'undefined' &&
          userMobile !== undefined &&
          userMobile !== null
            ? window.btoa(userMobile)
            : '';
      }
    } else {
      const countryCode = this.props.localeInfo.countryCode;
      const dataLayer = window.dataLayer;
      const {
        utm_source = null,
        utm_medium = null,
        utm_campaign = null,
        utm_term = null,
        utm_content = null
      } = extractUtmSourceFromUrl(this.props.location.search);
      if (utm_source) {
        localStorage.setItem('utmSource', JSON.stringify({ utm_source, utm_medium, utm_campaign, utm_term, utm_content }));
      } else if (!localStorage.getItem('utmSource')) {
        localStorage.setItem('utmSource', JSON.stringify({ utm_source, utm_medium, utm_campaign, utm_term, utm_content }));
      }
      const utmSource = JSON.parse(localStorage.getItem('utmSource'));
      let dataLayerData = {};
      const userEmail = null;
      const userMobile = null;
      const cartObject = this.props.cartData;
      const orderTotal =
        typeof cartObject !== 'undefined' &&
        cartObject !== null &&
        typeof cartObject.result !== 'undefined' &&
        typeof cartObject.result.totals !== 'undefined' &&
        typeof cartObject.result.totals.total !== 'undefined'
          ? cartObject.result.totals.total
          : null;
      if (this.dataLayerLoad) {
        dataLayerData = {
          event: 'VirtualPageView',
          EmailId: userEmail || null,
          PageUrl: window.location.href,
          mobile:
            typeof window !== 'undefined' &&
            typeof window.btoa !== 'undefined' &&
            userMobile !== undefined &&
            userMobile !== null
              ? window.btoa(userMobile)
              : '',
          netAmount: orderTotal,
          orderTotal,
          visitorPageType: 'HomePage',
          visitorPageTypeInfo: 'Static',
          visitorStore: 'revamp',
          visitorUtm_Source: utmSource.utm_source || '(direct)',
          visitorUtm_Cam: utmSource.utm_campaign || '(direct)',
          visitorUtm_Medium: utmSource.utm_medium || '(none)',

          // repeat for check if all goes ok then we have to remove repeated one
          utmSource: utmSource.utm_source || '',
          utmCampaign: utmSource.utm_campaign || '',
          utmMedium: utmSource.utm_medium || '',
          utmTerm: utmSource.utm_term || '',
          utmContent: utmSource.utm_content || '',
          website_source: `${countryCode} headless`
        };
        const dataLayerLength = dataLayer.length;
        dataLayer.push(dataLayerData);
        this.dataLayerLoad = false;
        this.dataLayerIndex = dataLayerLength;
      }
    }
  };

  handleScroll() {
    const scrollTop =
      window.pageYOffset !== undefined ? window.pageYOffset : document.documentElement.scrollTop;
    if (scrollTop + 200 >= document.documentElement.offsetHeight - window.innerHeight - 1200) {
      const { homepageData, renderData, updateRenderData } = this.props;
      const homeSections = homepageData.sections;
      const rowLimit = renderData ? renderData.length : 0;
      if (rowLimit < (homeSections && homeSections.length)) {
        const rowData = homeSections ? homeSections.slice(rowLimit, 4 + rowLimit) : null;
        updateRenderData(rowData);
      }
    }
  }

  triggerEventForhomepageDataload() {
    const event = new Customevent('homePageDataLoaded');
    event.dispatch();
    setTimeout(() => {
      if (typeof window.clevertap !== 'undefined') {
        window.clevertap.event.push('Page Visited', {
          pageName: 'Home Page',
        });
      }
    }, 500);
  }
  checkRepeatUser() {
    const { userInfo } = this.props;
    if (userInfo && userInfo?.result?.hasPlacedOrder) {
        this.isRepeatUser = true;
        sessionStorage.setItem('isRepeatUser', 'true');
    } else {
        this.isRepeatUser = false;
        sessionStorage.removeItem('isRepeatUser');
    }
    const hideElem = document.getElementsByClassName('hide-repeat');
    if (hideElem) {
        hideRepeatUserElem(this.isRepeatUser, hideElem);
    }
    sessionStorage.removeItem('backTrigger');
  }

  // To Close Offer Modal
  renderOfferModal(val) {
    this.setState({
      showOfferModal: val,
    });
    if (!val && sessionStorage.getItem('offerSelected')) sessionStorage.removeItem('offerSelected');
  }

  render() {
    const { showOfferModal } = this.state;
    const { renderData, homepageData, isYotpoWidgets, loadMoreCarousals, dataLocale, history } = this.props;
    const { footers, seo } = homepageData;
    const { LOADER, INR } = dataLocale;
    let linkTags = [];
    if (seo) {
      linkTags = [
        { rel: 'publisher', href: seo.publisher },
        { rel: 'canonical', href: seo.canonical },
      ];
      if (seo.amphtml) linkTags.push({ rel: 'amphtml', href: seo.amphtml });
    }

    return (
      <div className="home fullWidthContainer big-screen-wrapper">
        {seo && (
          <Helmet
            title={seo.title}
            meta={[
              { name: 'description', content: seo.description },
              { name: 'keywords', content: seo.keywords },
              { name: 'robots', content: 'INDEX,FOLLOW' },
              { property: 'og:site_name', content: 'Lenskart.com' },
              { property: 'og:type', content: 'lenskartwebsite:product' },
              { property: 'lenskartwebsite:price:currency', content: INR },
            ]}
            link={linkTags}
          />
        )}
        {!renderData.length && (
          <div className="text-center loding-product-count" style={{ marginTop: '30px' }}>
            <img
              alt={LOADER}
              src="//static.lenskart.com/skin/frontend/base/default/images/ajaxscroll/loader.gif"
            />
            <div>{dataLocale.LOADING_DATA}</div>
          </div>
        )}

        {/* Offer Modal : IPL */}
        {showOfferModal && <DesktopOfferModal dataLocale={dataLocale} renderOfferModal={val => this.renderOfferModal(val)} history={history} />}

        {renderData && (
          <div className="sectionComponents">
            <BannerAndCarouselRenderer
              dataLocale={dataLocale}
              isYotpoWidgets={isYotpoWidgets}
              componentsData={renderData}
            />
          </div>
        )}
        {renderData.length > 0 && !loadMoreCarousals && (
          <div
            className="clearfix text-center loding-product-count"
            style={{ marginTop: '30px', marginBottom: '30px' }}
          >
            <img
              alt={LOADER}
              src="//static.lenskart.com/skin/frontend/base/default/images/ajaxscroll/loader.gif"
            />
            <div>{dataLocale.LOADING_DATA}</div>
          </div>
        )}
        {footers && (
          <div className="footerComponents">
            <BannerAndCarouselRenderer dataLocale={dataLocale} componentsData={footers} />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  homepageData: state.home.homepageData,
  renderData: state.home.renderData,
  userInfo: state.common.userInfo,
  isYotpoWidgets: state.common.isYotpoWidgets,
  redisCommonData: state.common.redisCommonData,
  scrollY: state.home.scrollY,
  cartData: state.cart.cartData,
  loginStatus: state.common.login,
  loadMoreCarousals: state.home.loadMoreCarousals,
  dataLocale: state.locale,
  localeInfo: state.common.localeInfo,
});

const mapDispatchToProps = dispatch => {
  return {
    updateRenderData: data => dispatch(updateRenderData(data)),
    getCampaignData: data => dispatch(getCampaignData(data)),
    changeLogo: data => dispatch(changeLogo(data)),
    // loadCarousalsData: () => dispatch(loadCarousalsData())
  };
};

Home.defaultProps = {
  homepageData: {}
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
